import React, { useEffect, useState } from 'react';
import BlogBanner from '../../components/BlogBanner';
import BlogSection from '../../components/BlogSection';
import { getSeoByUrl } from '../../api/api';
import { Helmet } from "react-helmet-async";

const Blog = () => {
  const [seoData, setSeoData] = useState({});

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("blog");

        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };

    fetchSeoData();
  }, []);

  return (
    <div>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>
          {seoData.metaTitle || "Blog | Nutrillion"}
        </title>

        <meta
          name="description"
          content={seoData.metaDescription || "Nutrition tips and DNA based diet plans"}
        />

        {seoData.metaKeywords && (
          <meta name="keywords" content={seoData.metaKeywords} />
        )}

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={seoData.canonicalUrl || "https://nutrillion.one/blog"}
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content={seoData.ogType || "website"} />
        <meta property="og:title" content={seoData.ogTitle || seoData.metaTitle || "Blog | Nutrillion"} />
        <meta property="og:description" content={seoData.ogDescription || seoData.metaDescription || "Nutrition tips and DNA based diet plans"} />
        <meta property="og:url" content={seoData.ogUrl || seoData.canonicalUrl || "https://nutrillion.one/blog"} />
        {seoData.ogImage && (
          <meta property="og:image" content={seoData.ogImage} />
        )}

        {/* Twitter Card */}
        <meta name="twitter:card" content={seoData.twitterCard || "summary"} />
        <meta name="twitter:title" content={seoData.twitterTitle || seoData.metaTitle || "Blog | Nutrillion"} />
        <meta name="twitter:description" content={seoData.twitterDescription || seoData.metaDescription || "Nutrition tips and DNA based diet plans"} />
        {(seoData.twitterImage || seoData.ogImage) && (
          <meta name="twitter:image" content={seoData.twitterImage || seoData.ogImage} />
        )}

        {/* Schema Markup */}
       {seoData.schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(
              typeof seoData.schemaMarkup === "string"
                ? JSON.parse(seoData.schemaMarkup)
                : seoData.schemaMarkup
            )}
          </script>
        )}
      </Helmet>
      <BlogBanner />
      <BlogSection />
    </div>
  );
};

export default Blog;